import React from 'react';
import { X } from 'lucide-react';

const IncidentModal = ({ 
  setActiveModal, 
  incidentData, 
  setIncidentData, 
  createIncidentReport 
}) => (
  <div className="p-6">
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold">Quick Incident Report</h3>
      <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-gray-600">
        <X className="h-5 w-5" />
      </button>
    </div>
    
    <div className="space-y-4">
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 text-sm text-yellow-700">
        This creates a basic entry. Complete full incident report as soon as possible.
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
        <select
          value={incidentData.type}
          onChange={(e) => setIncidentData({...incidentData, type: e.target.value})}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        >
          <option value="near_miss">Near Miss</option>
          <option value="defect">Equipment Defect</option>
          <option value="injury">Injury/Illness</option>
          <option value="environmental">Environmental</option>
          <option value="security">Security</option>
          <option value="other">Other</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Brief Description *</label>
        <textarea
          value={incidentData.brief}
          onChange={(e) => setIncidentData({...incidentData, brief: e.target.value})}
          placeholder="Quick summary of what happened..."
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Severity</label>
        <select
          value={incidentData.severity}
          onChange={(e) => setIncidentData({...incidentData, severity: e.target.value})}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        >
          <option value="low">Low - Minor/No impact</option>
          <option value="medium">Medium - Some impact</option>
          <option value="high">High - Significant impact</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Immediate Action Taken</label>
        <input
          type="text"
          value={incidentData.actionTaken}
          onChange={(e) => setIncidentData({...incidentData, actionTaken: e.target.value})}
          placeholder="e.g., Area secured, First aid given"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div className="flex gap-2 pt-4">
        <button
          onClick={() => setActiveModal(null)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={createIncidentReport}
          disabled={!incidentData.brief}
          className="flex-1 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:bg-gray-400"
        >
          Create Quick Report
        </button>
      </div>
    </div>
  </div>
);

export default IncidentModal;